"use client"

import { ArrowRight, CheckCircle } from "lucide-react"
import { buttonClassName } from "@/components/ui/button"
import { useInView } from "@/hooks/use-in-view"
import { cn } from "@/lib/utils"

const benefits = [
  "Análisis inicial sin compromiso",
  "Propuesta personalizada en 48h",
  "Sin costos ocultos",
  "Soporte continuo incluido",
]

export function CTA() {
  const { ref: titleRef, isInView: titleInView } =
    useInView<HTMLHeadingElement>()

  return (
    <section className="py-16 lg:py-16">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="relative overflow-hidden rounded-2xl bg-[#ee4b00] px-6 py-16 sm:px-16 sm:py-10 lg:px-16">
          {/* Background pattern */}
          <div className="absolute inset-0 -z-10">
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,rgba(255,255,255,0.15),transparent_50%)]" />
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_80%,rgba(0,0,0,0.1),transparent_50%)]" />
          </div>

          <div className="mx-auto max-w-3xl text-center">
            <h2
              ref={titleRef}
              className={cn(
                "font-work text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-titulo-negro uppercase transition-all duration-1000 ease-out will-change-transform",
                "motion-reduce:transition-none motion-reduce:transform-none",
                titleInView
                  ? "opacity-100 translate-y-0"
                  : "opacity-0 translate-y-3",
              )}
            >
              Dale un upgrade a tu forma de trabajar.
            </h2>
            <p
              className={cn(
                "mt-6 text-lg text-titulo-hero/80 font-jetbrains font-extralight transition-all duration-1000 ease-out will-change-transform",
                "motion-reduce:transition-none motion-reduce:transform-none",
                titleInView
                  ? "opacity-100 translate-y-0"
                  : "opacity-0 translate-y-3",
              )}
            >
              Agenda una consulta gratuita y descubre cómo podemos ayudarte a automatizar 
              tus tareas diarias y mejorar la eficiencia de tu empresa.
            </p>

            {/* Benefits */}
            <div className="mt-8 flex flex-wrap items-center justify-center gap-x-8 gap-y-3 font-jetbrains font-extraligth">
              {benefits.map((benefit, index) => (
                <div
                  key={index}
                  className="flex items-center gap-2 text-md text-titulo-negro/70"
                >
                  <CheckCircle className="h-4 w-4" />
                  {benefit}
                </div>
              ))}
            </div>

            {/* CTA Button */}
            <div className="mt-10">
              <a
                href="#contacto"
                className={buttonClassName(
                  "secondary",
                  "bg-background-button-beige text-cyan-700 hover:opacity-90",
                )}
              >
                Solicitar análisis gratuito
                <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
